import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import { CSSProperties, FC, ReactNode, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useWindowSize } from "hooks";

type Props = {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
};

const HeroAccordion: FC<Props> = withErrorBoundary(({ isOpen, children, className = "" }) => {
  const TRANSITION_DURATION_MS = 250;

  const [contentHeight, setContentHeight] = useState(0);

  const contentRef = useRef<HTMLDivElement>(null);

  const { width } = useWindowSize();

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen, width]);

  return (
    <StyledHeroAccordion
      style={
        {
          "--content-height": `${contentHeight}px`,
          "--transition-duration": `${TRANSITION_DURATION_MS / 1000}s`,
        } as CSSProperties
      }
      className={cn(className, {
        HeroAccordion_isOpen: isOpen,
      })}
    >
      <div className="HeroAccordion__content" ref={contentRef}>
        {children}
      </div>
    </StyledHeroAccordion>
  );
}, {});

const StyledHeroAccordion = styled.div`
  height: 0;
  overflow: hidden;
  transition: height var(--transition-duration) ease;

  &.HeroAccordion_isOpen {
    height: var(--content-height);
  }
`;

export { HeroAccordion };
